<template>
  <el-dialog
    title="修改规格"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form ref="form" :model="editProductSpecInfo" label-width="100px">
      <el-form-item 
        label="名称" 
        prop="specName"
        :rules="[{ required: true, message: '规格名称不能为空', trigger: 'blur' }]"
      >
        <el-input 
          v-model="editProductSpecInfo.specName" 
          placeholder="必填，请填写规格名称"
        />
      </el-form-item>

      <div class="form-tips">
        <span>如：颜色，大小，容量，尺寸，重量</span>
        <span style="float: right">如：红色，小，500ML，5.5寸，1kg</span>
      </div>

      <div v-for="(item, index) in editProductSpecInfo.specDetails" :key="index" class="spec-item">
        <el-form-item 
          label="规格" 
          :prop="`specDetails[${index}].detailName`"
          :rules="[{ required: true, message: '规格不能为空', trigger: 'blur' }]"
        >
          <input v-model="item.detailName" placeholder="必填，请填写规格" />
        </el-form-item>
        <el-form-item 
          label="值" 
          :prop="`specDetails[${index}].detailValue`"
          :rules="[{ required: true, message: '规格值不能为空', trigger: 'blur' }]"
        >
          <input v-model="item.detailValue" placeholder="必填，请填写规格值" />
        </el-form-item>
        <div class="spec-action">
          <i 
            v-if="index !== editProductSpecInfo.specDetails.length - 1"
            class="el-icon-remove" 
            @click="_deleteEditSpecDetail(item)"
          />
          <i 
            v-if="index === editProductSpecInfo.specDetails.length - 1"
            class="el-icon-circle-plus" 
            @click="_addEditSpecDetail"
          />
        </div>
      </div>

      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="editProductSpec">保存</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { updateProductSpec } from '@/api/goods/productSpecApi'
import { getShopId } from '@/api/shop/shopApi'
import { getUuid } from '@/utils/commonUtil'

export default {
  name: 'EditProductSpec',
  data() {
    return {
      dialogVisible: false,
      editProductSpecInfo: {
        specId: '',
        specName: '',
        specDetails: []
      }
    }
  },
  methods: {
    open(row) {
      this.refreshEditProductSpecInfo()
      this.editProductSpecInfo = JSON.parse(JSON.stringify(row))
      if (row.productSpecDetails) {
        this.editProductSpecInfo.specDetails = row.productSpecDetails.map(item => ({
          ...item,
          id: getUuid()
        }))
      }
      this.dialogVisible = true
    },
    refreshEditProductSpecInfo() {
      this.editProductSpecInfo = {
        specId: '',
        specName: '',
        specDetails: []
      }
    },
    async editProductSpec() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        this.editProductSpecInfo.shopId = getShopId()
        const res = await updateProductSpec(this.editProductSpecInfo)
        
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('修改规格失败:', error)
      }
    },
    _addEditSpecDetail() {
      this.editProductSpecInfo.specDetails.push({
        id: getUuid(),
        detailName: '',
        detailValue: '',
        detailId: '-1'
      })
      this.$forceUpdate()
    },
    _deleteEditSpecDetail(item) {
      const index = this.editProductSpecInfo.specDetails.findIndex(d => d.id === item.id)
      if (index > -1) {
        this.editProductSpecInfo.specDetails.splice(index, 1)
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.form-tips {
  margin-bottom: 20px;
  color: #999;
  font-size: 14px;
}

.spec-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.spec-item >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 20px;
  flex: 1;
}

.spec-item >>> input {
  width: 100%;
  height: 40px;
  line-height: 1.5;
  padding: 5px 15px;
  font-size: 14px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  box-sizing: border-box;
}

.spec-item >>> input:focus {
  outline: none;
  border-color: #409eff;
}

.spec-item >>> input:hover {
  border-color: #c0c4cc;
}

.spec-item >>> input::placeholder {
  color: #c0c4cc;
}

.spec-action {
  line-height: 40px;
  margin-left: 10px;
  margin-top: 2px;
}

.spec-action i {
  font-size: 20px;
  cursor: pointer;
  color: #409EFF;
}

.spec-action i:hover {
  color: #66b1ff;
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .spec-item {
    flex-direction: column;
  }
  
  .spec-item >>> .el-form-item {
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .spec-action {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>